import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/ApplicationStore";
import axios from "axios";
import { BootstrapVue } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Auth0Plugin from "./auth0-plugin";

Vue.prototype.$http = axios;
// Set authorization header based on auth method
const authMethod = localStorage.getItem("auth_method");
if (authMethod === 'legacy') {
  const access = localStorage.getItem("access");
  if (access) {
    Vue.prototype.$http.defaults.headers.common["Authorization"] = "Bearer " + access;
  }
} else if (authMethod === 'auth0') {
  const auth0Token = localStorage.getItem("auth0_token");
  if (auth0Token) {
    Vue.prototype.$http.defaults.headers.common["Authorization"] = "Bearer " + auth0Token;
  }
}

Vue.use(BootstrapVue);
Vue.use(Auth0Plugin, { store });

store.dispatch("setBaseURL").then(() => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}),
  (Vue.config.productionTip = false);
// Request interceptor to add the correct token based on auth method
axios.interceptors.request.use(
  (config) => {
    const authMethod = store.state.auth.auth_method;

    if (authMethod === 'auth0') {
      // Use cached Auth0 token from store
      const cachedToken = store.state.auth.auth0_token;
      if (cachedToken) {
        config.headers["Authorization"] = `Bearer ${cachedToken}`;
      }
    } else if (authMethod === 'legacy') {
      // Use legacy JWT token
      const accessToken = store.state.auth.access_token;
      if (accessToken) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    if (response.config.method != "get") {
      store.dispatch("newMessage", {
        status: response.status,
        message: "👍",
      });
    }
    return response;
  },
  async (error) => {
    if (!error.response || error.response.status != 401) {
      return new Promise((resolve, reject) => {
        store.dispatch("newMessage", {
          status: error.response?.status || 0,
          message: error.response?.data || error.message || "Network error",
        });
        reject(error);
      });
    }

    const authMethod = store.state.auth.auth_method;

    // For Auth0 authenticated users, try to refresh the token using refresh token
    if (authMethod === 'auth0' && Vue.prototype.$auth0) {
      try {
        console.log('401 received, attempting to refresh Auth0 token using refresh token...');
        const token = await Vue.prototype.$auth0.getToken();
        console.log('Auth0 token refreshed successfully');
        if (token) {
          // Store the new token
          store.commit("setAuth0Token", token);

          // Retry the original request with new token
          const config = error.config;
          config.headers["Authorization"] = `Bearer ${token}`;
          return axios.request(config);
        } else {
          console.error('Auth0 getToken returned null/undefined');
          store.commit("auth_logout");
          return Promise.reject(error);
        }
      } catch (refreshError) {
        console.error('Auth0 token refresh failed:', refreshError);
        store.commit("auth_logout");
        return Promise.reject(error);
      }
    }

    // Legacy JWT handling
    if (
      error.config.url ==
      store.state.baseURL + store.state.apiRoutes.refresh
    ) {
      store.commit("auth_logout");
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
    if (error.config.url == store.state.baseURL + store.state.apiRoutes.token) {
      return new Promise((resolve, reject) => {
        store.dispatch("newMessage", {
          status: error.response.status,
          message: "Error logging in, check credentials.",
        });
        reject(error);
      });
    }
    return store
      .dispatch("auth_refresh")
      .then((token) => {
        const config = error.config;
        config.headers["Authorization"] = `Bearer ${token}`;
        return new Promise((resolve, reject) => {
          axios
            .request(config)
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      })
      .catch((error) => {
        Promise.reject(error);
      });
  }
);
